import React, { useState } from "react";
import {
  Col,
  Form,
  Row,
  Tab,
  Tabs,
  Modal,
  Table,
  Button,
} from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import TableTemp from "../../../Components/TableTemplate/Table";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import NoDataImg from "../../../Assets/Images/no-data-img.png";
import trash from "../../../Assets/Images/trash.png";
import {
  dateFormat,
  formatDateNoTime,
  formatDate,
  numberFormat,
  refreshPage,
  toastStyle,
  getTodayDate,
  getType,
  TokenExpiry,
  getTodayDateISO,
  getTodayDateISOFormat,
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";

import MultiDatePicker, { DateObject } from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import "react-multi-date-picker/styles/colors/green.css";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";

import { Fragment } from "react";
import Moment from "moment";
import InputError from "../../../Components/InputError/InputError";
import { validatePayrollModal } from "./../../../Helpers/Validation/Employees/PayrollValidation";
import { CSVLink, CSVDownload } from "react-csv";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import ReactLoading from "react-loading";
import * as XLSX from "xlsx";

import { getAllBanks } from "../../../Helpers/apiCalls/banksAPi";
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import {
  getAllPayroll,
  deletePayroll,
} from "./../../../Helpers/apiCalls/Employees/PayrollApi";
import { createUploadSchedule } from "./../../../Helpers/apiCalls/Employees/PayrollApi";
import upload from "../../../Assets/Images/upload.png";
import { Upload } from "antd";
import { getAllBranches } from "./../../../Helpers/apiCalls/Manage/Branches";
import {
  createSchedule,
  createScheduleMultiple,
  getSchedule,
  updateSchedule,
} from "./../../../Helpers/apiCalls/Employees/SchedulerApi";
import { validateSchedule } from './../../../Helpers/Validation/Employees/SchedulerValidation';
import Footer from "../../../Components/Footer/Footer";


export default function FormSchedule({ add, edit }) {
  const { Dragger } = Upload;
  const { type, id, shop } = useParams();
  let navigate = useNavigate();
  var dateToday = getTodayDate();
  const accountType = getType();
  const [inactive, setInactive] = useState(true);
  const [filterConfig, setFilterConfig] = useState({
    employee_id: "",
    employee_name: "",
    date_from: "",
    date_to: "",
    user: accountType,
  });
  const [isError, setIsError] = useState({
    branch_id: false,
    date_from: false,
    date_to: false,
    date: false,
    schedules: false,
    employee_id: false,
    time_start: false,
    time_end: false,
    break_end: false,
    time_end_validation: false,
    break_end_validation: false,
  });

  const days = [
    { value: "sunday", label: "Sunday" },
    { value: "monday", label: "Monday" },
    { value: "tuesday", label: "Tuesday" },
    { value: "wednesday", label: "Wednesday" },
    { value: "thursday", label: "Thursday" },
    { value: "friday", label: "Friday" },
    { value: "saturday", label: "Saturday" },
  ];

  // const [branches, setBranches] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [allData, setAllData] = useState([]);
  const [allDataCsv, setAllDataCsv] = useState([]);
  const [totalNet, setTotalNet] = useState("0");
  const [checkedPayments, setCheckedPayments] = useState([]);
  const [selectedTab, setSelectedTab] = useState("submitted");
  const [dailySales, setDailySales] = useState([]);
  const [isClicked, setIsClicked] = useState(false);
  const [file, setFile] = useState("");
  const [fileList, setFileList] = useState([]);
  const [addDetails, setAddDetails] = useState({
    type: type
  });
  const [branches, setBranches] = useState([]);
  const [selectedDays, setSelectedDays] = useState([]);
  const [schedDetails, setSchedDetails] = useState([
    {
      employee_id: "",
      time_start: "",
      break_time: "",
      break_end: "",
      break_hours: 0,
      time_end: "",
      hours_total: 0,
      selected_days: [],
    },
  ]);
  const [values, setValues] = useState([dateToday]);

  /* delete modal handler */
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);
  /* add modal handler */
  const [showAddModal, setShowAddModal] = useState(false);
  const handleShowAddModal = () => setShowAddModal(true);
  const handleCloseAddModal = () => setShowAddModal(false);

  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState({
    label: "",
    value: "",
  });
  const [selectedMonthFrom, setSelectedMonthFrom] = useState("");
  const [selectedMonthTo, setSelectedMonthTo] = useState("");
  const today = Moment().format("MM/DD/YYYY");

  
  
  

  const excelHeaders = [
    { label: "Payroll Range", key: "payroll_range" },
    { label: "Disbursement Date", key: "disbursement_date" },
    { label: "Type", key: "disbursement_type" },
    { label: "Employee Name", key: "employee_name" },
    { label: "Department", key: "department_name" },
    { label: "Payee ID", key: "payee_id" },
    { label: "Net Pay", key: "grand_total" },
    { label: "Total Working Hours", key: "working_hours" },
    { label: "Rate", key: "rate" },
    { label: "Basic Pay", key: "basic_pay" },
    { label: "Total Wages", key: "total_addition" },
    { label: "Total Deductions", key: "total_deduction" },
    { label: "Transportation Allowance", key: "transportation_allowance" },
    { label: "Other Allowances", key: "other_allowances" },
    { label: "Holiday", key: "holidays" },
    { label: "Other Wages", key: "other_wages" },
    { label: "Philhealth", key: "philhealth" },
    { label: "SSS", key: "sss" },
    { label: "Pagibig", key: "pagibig" },
    { label: "Shortage", key: "shortage" },
    { label: "Cash Advance", key: "cash_advance" },
    { label: "Other Deductions", key: "other_deductions" },
    { label: "SSS Loan", key: "sss_loan" },
    { label: "Pagibig Loan", key: "pagibig_loan" },
    { label: "Remarks", key: "remarks" },
  ];

  // SEARCH USER
  function handleOnSearch(e) {
    const { name, value } = e.target;
    setFilterConfig((prev) => {
      return { ...prev, [name]: value };
    });
  }

  function handleAddModal(e) {
    if (
      validatePayrollModal(
        selectedEmployee,
        selectedMonthFrom,
        selectedMonthTo,
        setIsError
      )
    ) {
      navigate(`/payroll/add/${selectedEmployee.value}`, {
        state: {
          selectedEmployee: selectedEmployee,
          date_from: selectedMonthFrom,
          date_to: selectedMonthTo,
        },
      });
    }
  }

  const handleAddChange = (e, select) => {
    if (select) {
      const { label, value } = e;
      setAddDetails((prevState) => ({
        ...prevState,
        ["branch_id"]: value,
        ["branch_id_value"]: {
          label: label,
          value: value,
        },
      }));
    } else {
      const { name, value } = e.target;
      if (name === "date_from") {
        var dateto = new Date(value);
        dateto.setDate(dateto.getDate() + 14);
        setAddDetails((prevState) => ({
          ...prevState,
          [name]: value,
          ["date_to"]: getTodayDateISOFormat(dateto),
        }));
      } else {
        setAddDetails((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    }
  };
  
  

  // var format = {format: "YYYY-MM-DD"}
  // function convert (date, format) {
  //     
  //     let object = { date, format }
  //     var data = new DateObject(object).format()
  //     
  // }

  function handleScheduleChange(e, row, type) {
    const temp = [...schedDetails]; // Create a copy of schedDetails to modify

    if (type === "select") {
      temp[row].employee_id_value = { label: e.label, value: e.value };
      temp[row].employee_id = e.value;
      temp[row].employee_name = e.label;
    } else if (type === "multiple_select") {
      
      var dates = e.map((dateObj) => {
        var info = {};
        var format = "YYYY-MM-DD";
        var date_val = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
        
        info.value = date_val;
        return info;
      });

      temp[row].selected_days = dates;
      temp[row].selected_days_value = e;
    } else {
      const { name, value } = e.target;

      temp[row][name] = value === "" ? 0 : value;

      // Check if break_time and break_end are both available
      if (
        (name === "break_end" && temp[row].break_time !== "") ||
        (name === "break_time" && temp[row].break_end !== "")
      ) {
        const format = "HH:mm"; // Define the time format
        const breakStart = Moment(temp[row].break_time, format);
        const breakEnd = Moment(temp[row].break_end, format);

        // Calculate the difference in minutes
        const diffMinutes = breakEnd.diff(breakStart, "minutes");

        // Calculate the difference in hours with fractional parts
        const breakHours = diffMinutes / 60;

        temp[row].break_hours = breakHours.toFixed(2); // Limit to 2 decimal places

        if (temp[row].time_start !== "" && temp[row].time_end !== "") {
          const format = "HH:mm";
          const breakStart = Moment(temp[row].time_start, format);
          const breakEnd = Moment(temp[row].time_end, format);

          const diffMinutes = breakEnd.diff(breakStart, "minutes");
          const totalHours = diffMinutes / 60 - breakHours;

          temp[row].hours_total = totalHours.toFixed(2); // Limit to 2 decimal places
        }
      }

      if (
        (name === "time_end" && temp[row].time_start !== "") ||
        (name === "time_start" && temp[row].time_end !== "")
      ) {
        const format = "HH:mm"; // Define the time format
        const breakStart = Moment(temp[row].time_start, format);
        const breakEnd = Moment(temp[row].time_end, format);

        // Calculate the difference in minutes
        const diffMinutes = breakEnd.diff(breakStart, "minutes");

        // Calculate the difference in hours with fractional parts
        const breakHours = diffMinutes / 60 - temp[row].break_hours;

        temp[row].hours_total = breakHours.toFixed(2); // Limit to 2 decimal places
      }
    }

    setSchedDetails(temp); // Update the state with the modified array
  }
  

  function addSchedBtn() {
    const newEmployee = {
      employee_id: "",
      time_start: "",
      break_time: "",
      break_end: "",
      break_hours: 0,
      time_end: "",
      hours_total: 0,
      selected_days: [],
    };
    setSchedDetails((prev) => [...prev, newEmployee]);
  }

  

  function handleRemoveSched(id) {
    // setIsChanged(true);
    const rowId = id;
    const newEmployeeList = [...schedDetails];
    newEmployeeList.splice(rowId, 1);
    setSchedDetails(newEmployeeList);
    // setTimeout(() => setIsChanged(false), 1);
  }

  async function fetchEmployees() {
      const response = await getAllEmployees();
      if (response.error) {
        setEmployees([]);
      } else {
        let result = response.data.data.map((data) => {
          var employee = data;
          employee.label = data.first_name + " " + data.last_name;
          employee.value = data.id;
          return employee;
        });
        setEmployees(result);
      }
  }

  async function fetchBranches() {
    setShowLoader(true);
    setBranches([]);

      const response = await getAllBranches();
      if (response.error) {
      } else {
        var allBranches = response.data.data.data
          .filter((data) => {
            return data.is_franchise === "0";
          })
          .map((data) => {
            var branch = data;
            branch.label = data.name;
            branch.value = data.id;
            return branch;
          });
        setBranches(allBranches);
      }
    setShowLoader(false);
  }

  async function fetchData() {
    setShowLoader(true);
    setAddDetails([]);
    setSchedDetails([]);

      const response = await getSchedule(id);
      
      if (response.data) {
        var data = [...response.data.data];
        var sched = data.map((bill) => {
          var details = bill;
          details.employee_id_value = {
            label: bill.employee_name,
            value: bill.employee_id,
          };
          return details;
        });
        setSchedDetails(sched);
  
        var add_details = {};
        add_details.id = data[0].id;
        add_details.branch_id = data[0].branch_id;
        add_details.branch_id_value = {
          label: data[0].branch_name,
          value: data[0].branch_id,
        };
        add_details.date = data[0].date;
        // add_details.date = getTodayDateISOFormat(data.date)
        setAddDetails(add_details);
      }
    setShowLoader(false);
  }

  function renderTable() {
    return (
      <Table className="ps-table">
        <thead>
          <tr>
            <th className="color-gray">Crew</th>
            <th className="color-gray">Start</th>
            <th className="color-gray">Break Start</th>
            <th className="color-gray">Break End</th>
            <th className="color-gray">hrs break</th>
            <th className="color-gray">End</th>
            <th className="color-gray">Total Worked</th>
            {add && type === "multiple" && (
              <th className="color-gray">Day Off</th>
            )}
            <th className="color-gray">Action</th>
          </tr>
        </thead>
        <tbody>
          {schedDetails.map((employee, index) => {
            
            return (
              <tr>
                {add && (
                  <td>
                    <Select
                      className="react-select-container"
                      classNamePrefix="react-select"
                      placeholder="Select Employee..."
                      value={employee.employee_id_value}
                      options={employees}
                      onChange={(e) => handleScheduleChange(e, index, "select")}
                    />
                    <InputError
                      isValid={isError.employee_id}
                      message={"Employee is required"}
                    />
                  </td>
                )}
                {edit && (
                  <td>
                    <span>{employee.employee_name}</span>
                  </td>
                )}
                <td>
                  <Form.Control
                    type="time"
                    name="time_start"
                    className="nc-modal-custom-text"
                    value={employee.time_start}
                    onChange={(e) => handleScheduleChange(e, index)}
                  />
                  <InputError
                    isValid={isError.time_start}
                    message={"Start is required"}
                  />
                </td>
                <td>
                  <Form.Control
                    type="time"
                    name="break_time"
                    className="nc-modal-custom-text"
                    defaultValue={employee.break_time}
                    onChange={(e) => handleScheduleChange(e, index)}
                  />
                  <InputError
                    isValid={isError.break_time}
                    message={"Break start is required"}
                  />
                </td>
                <td>
                  <Form.Control
                    type="time"
                    name="break_end"
                    className="nc-modal-custom-text"
                    defaultValue={employee.break_end}
                    onChange={(e) => handleScheduleChange(e, index)}
                    min={employee.break_hour}
                  />
                  <InputError
                    isValid={isError.break_end}
                    message={"Break end is required"}
                  />
                  <InputError
                    isValid={isError.break_end_validation}
                    message={"Break end cannot be earlier than break start"}
                  />
                </td>
                <td>
                  <span>{employee.break_hours}</span>
                </td>
                <td>
                  <Form.Control
                    type="time"
                    name="time_end"
                    className="nc-modal-custom-text"
                    defaultValue={employee.time_end}
                    onChange={(e) => handleScheduleChange(e, index)}
                    min={employee.time_start}
                  />
                  <InputError
                    isValid={isError.time_end}
                    message={"End is required"}
                  />
                  <InputError
                    isValid={isError.time_end_validation}
                    message={"End cannot be earlier than start"}
                  />
                </td>
                <td>
                  <span>{employee.hours_total}</span>
                </td>
                {add && type === "multiple" && (
                  <>
                    <td>
                      <MultiDatePicker
                        multiple
                        className="green"
                        value={employee.selected_days_value}
                        onChange={(e) =>
                          handleScheduleChange(e, index, "multiple_select")
                        }
                        plugins={[<DatePanel />]}
                      />
                      {/* <Select
                                                    name="day_off"
                                                    className="nc-modal-custom-text"
                                                    options={days}
                                                    value = {employee.selected_days}
                                                    onChange={(e) => handleScheduleChange(e, index, "multiple_select")}
                                                    placeholder={`Select Days`}
                                                    isMulti={true}
                                                    isSearchable={true}
                                                /> */}
                    </td>
                  </>
                )}
                <td>
                  <div className="align-middle">
                    <img
                      src={trash}
                      alt="delete"
                      onClick={() => handleRemoveSched(index)}
                      className="cursor-pointer"
                    />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  async function handleCreateSchedule() {
    if(validateSchedule(addDetails, schedDetails, setIsError)) {
      setIsClicked(true);
        if (type === "single") {
          const response = await createSchedule(addDetails, schedDetails);
          
          if (response.data) {
            toast.success("Successfully added schedule!", {
              style: toastStyle(),
            });
  
            setTimeout(() => {
              navigate("/scheduler");
            }, 1000);
          } else {
            toast.error("Something went wrong", {
              style: toastStyle(),
            });
            // toast.error(response.error.response?.data.messages.error, {
            //     style: toastStyle(),
            // });
            setTimeout(() => {
              setTimeout(() => {
                // navigate("/scheduler")
                setIsClicked(false);
              }, 1000);
            }, 1000);
          }
        } else if (type === "multiple") {
          const response = await createScheduleMultiple(addDetails, schedDetails);
          
          if (response.data) {
            toast.success("Successfully generated schedule!", {
              style: toastStyle(),
            });
            setTimeout(() => {
              navigate("/scheduler");
            }, 1000);
          } else {
            toast.error("Something went wrong", {
              style: toastStyle(),
            });
            setTimeout(() => {
              setTimeout(() => {
                setIsClicked(false);
              }, 1000);
            }, 1000);
          }
        }
    } else {
      toast.error("Please fill in all required fields and make sure all data are correct", {
        style: toastStyle(),
    });
    }
  }

  async function handleUpdateSchedule() {
    setIsClicked(true);
    
    const response = await updateSchedule(addDetails, schedDetails);
    
    if (response.data) {
      toast.success("Successfully updated schedule!", {
        style: toastStyle(),
      });
      setTimeout(() => {
        navigate("/scheduler");
      }, 1000);
    } else {
      toast.error("Something went wrong", {
        style: toastStyle(),
      });
      // toast.error(response.error.response?.data.messages.error, {
      //     style: toastStyle(),
      // });
      setTimeout(() => {
        setTimeout(() => {
          // navigate("/scheduler")
          setIsClicked(false);
        }, 1000);
      }, 1000);
    }
  }

  React.useEffect(() => {
    fetchEmployees();
    fetchBranches();
    if (edit) {
      fetchData();
    }
  }, []);

  React.useEffect(() => {}, [filterConfig]);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"PAYROLL"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={7}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
                {" "}
                {add ? "Add Schedule" : "Edit Schedule"}{" "}
              </h1>
          </Col>
        </Row>
        <div className="print-container px-3 py-2 ">
          <Row className="mt-4 pt-3">
            <Col xs={12} lg={6} >
              <span className="PI-modal-label ">BRANCH</span>
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Branch..."
                value={addDetails.branch_id_value}
                options={branches}
                onChange={(e) => handleAddChange(e, "select")}
              />
              <InputError
                isValid={isError.branch_id}
                message={"Branch is required"}
              />
            </Col>
            {type === "multiple" && (
              <>
                <Col xs={12} lg={3} className="mt-4 mt-lg-0">
                  <span className="PI-modal-label ">DATE FROM</span>
                  <Form.Control
                    type="date"
                    name="date_from"
                    className="nc-modal-custom-text"
                    value={addDetails.date_from}
                    onChange={(e) => {
                      handleAddChange(e);
                    }}
                  />
                  <InputError
                    isValid={isError.date_from}
                    message={"Date from is required"}
                  />
                </Col>
                <Col xs={12} lg={3} className="mt-4 mt-lg-0">
                  <span className="PI-modal-label ">DATE TO</span>
                  <Form.Control
                    type="date"
                    name="date_to"
                    className="nc-modal-custom-text"
                    value={addDetails.date_to}
                    onChange={(e) => {
                      handleAddChange(e);
                    }}
                  />
                  <InputError
                    isValid={isError.date_to}
                    message={"Date to is required"}
                  />
                </Col>
              </>
            )}
            {type === "single" && (
              <>
                <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                  <span className="PI-modal-label ">DATE</span>
                  <Form.Control
                    type="date"
                    name="date"
                    className="nc-modal-custom-text"
                    value={addDetails.date}
                    onChange={(e) => {
                      handleAddChange(e);
                    }}
                    disabled={edit ? true : false}
                  />
                  <InputError
                    isValid={isError.date}
                    message={"Date is required"}
                  />
                </Col>
              </>
            )}
          </Row>
          <Row className="mt-2 pt-3"></Row>
          <Row className="nc-modal-custom-row">
            <div className="edit-purchased-items ms-2">
              {schedDetails.length === 0 ? (
                <span>No Data Found!</span>
              ) : (
                renderTable()
              )}
            </div>
          </Row>
          <Row className="pt-3 PO-add-item">
            <InputError
              isValid={isError.schedules}
              message={"There must be at least one schedule!"}
            />
            {/* <InputError
              isValid={isError.listInfo}
              message={"Please make sure to fill all inputs for each employee!"}
            /> */}
          </Row>
          {type === "multiple" && (
            <Row className="pt-2 PO-add-item justify-content-start me-2">
              <Button type="button" onClick={() => addSchedBtn()}>
                Add
              </Button>
            </Row>
          )}
          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            {isClicked === true && (
              <div className="button-primary d-flex justify-content-center me-3">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            )}
            {add && type === "multiple" && (
              <>
                {isClicked === false && (
                  <button
                    type="button"
                    className="button-primary me-3"
                    onClick={() => handleCreateSchedule()}
                  >
                    Generate
                  </button>
                )}
              </>
            )}
            {add && type === "single" && (
              <>
                {isClicked === false && (
                  <button
                    type="button"
                    className="button-primary me-3"
                    onClick={() => handleCreateSchedule()}
                  >
                    Add
                  </button>
                )}
              </>
            )}
            {edit && (
              <>
                {isClicked === false && (
                  <button
                    type="button"
                    className="button-primary me-3"
                    onClick={() => handleUpdateSchedule()}
                  >
                    Submit
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <Modal
        show={showAddModal}
        onHide={handleCloseAddModal}
        size="lg"
        centered
      >
        <Modal.Body>
          <span className="PI-modal-header">ADD SCHEDULER</span>
          <div className="PI-modal-body mt-3">
            <span className="PI-modal-label">EMPLOYEE NAME</span>
            <Select
              className="react-select-container mb-4"
              classNamePrefix="react-select"
              placeholder="Select Employee..."
              value={selectedEmployee}
              options={employees}
              onChange={(e) =>
                setSelectedEmployee({
                  label: e.label,
                  value: e.value,
                })
              }
            />
            <InputError
              isValid={isError.employee_id}
              message={"Employee is required"}
            />
            <span className="PI-modal-label ">DATE FROM</span>
            <Form.Control
              type="date"
              name="payroll_month_from"
              className="nc-modal-custom-text"
              onChange={(e) => {
                setSelectedMonthFrom(e.target.value);
              }}
            />
            <InputError
              isValid={isError.payroll_month_from}
              message={"Month from is required"}
            />
            <span className="PI-modal-label ">DATE TO</span>
            <Form.Control
              type="date"
              name="payroll_month_to"
              className="nc-modal-custom-text"
              onChange={(e) => {
                setSelectedMonthTo(e.target.value);
              }}
            />
            <InputError
              isValid={isError.payroll_month_to}
              message={"Month to is required"}
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="PI-modal-buttons">
          <button
            type="button"
            onClick={handleCloseAddModal}
            className="button-secondary"
          >
            Close
          </button>
          <button
            type="button"
            onClick={handleAddModal}
            className="button-primary"
          >
            Continue
          </button>
        </Modal.Footer>
      </Modal>
      <Footer/>
    </div>
  );
}
